import { useMainObjectInputs } from '@pages/TimeLineCreateOrEdit/hooks/useMainObjectInputs'

import { useHandlers } from './useHandlers'

type UseInputsType = ReturnType<typeof useHandlers>

export const useInputs = (props: UseInputsType) => {
  const mainObjectInputs = useMainObjectInputs(props)

  return {
    ...mainObjectInputs,
  }
}
